/**
 * Os guardas do que chega pela URL, e o codigo curto de cada estado.
 *
 * Ver a nota sobre onde uma tabela de codigo mora, mais abaixo em `CodeTable`.
 */
// ========== O QUE CHEGA DE FORA ==========
/*
 * O endereco e ENTRADA NAO CONFIAVEL.
 *
 * Qualquer pessoa edita o hash, e o que vem de la entra na aplicacao como se tivesse
 * sido escrito por ela: `page=-1`, `tipo=abc`, `metric=<script>`, um filtro de dez mil
 * caracteres. Cifrar o endereco nao resolve isto - contra quem edita o proprio
 * navegador, a chave esta com ele. O que resolve e conferir na CHEGADA.
 *
 * Estas funcoes sao o lugar dessa conferencia, e as classes de keys sao quem as
 * chama: e nelas que o valor cru deixa de ser texto e vira estado da aplicacao.
 */
/** Um numero de pagina vindo de fora: inteiro, de 1 ate o teto. */
export function safePage(value, max = 10_000) {
    if (typeof value !== 'number' || !Number.isFinite(value)) {
        return 1;
    }
    return Math.min(Math.max(1, Math.trunc(value)), max);
}
/** Um identificador vindo de fora: inteiro positivo, ou nada. */
export function safeId(value) {
    if (typeof value !== 'number' || !Number.isFinite(value) || value <= 0) {
        return undefined;
    }
    return Math.trunc(value);
}
/** Um valor de lista fechada, com padrao para o que nao estiver nela. */
export function safeOneOf(value, allowed, fallback) {
    return allowed.includes(value) ? value : fallback;
}
/** O codigo de um valor, ou `undefined` quando o valor nao esta na tabela. */
export function encodeOneOf(value, codes) {
    if (value === undefined) {
        return undefined;
    }
    for (const [code, known] of Object.entries(codes)) {
        if (known === value) {
            return code;
        }
    }
    return undefined;
}
/** O valor de um codigo vindo de fora, com padrao para o que nao estiver na tabela. */
export function decodeOneOf(code, codes, fallback) {
    return (typeof code === 'string' ? codes[code] : undefined) ?? fallback;
}
/** Como o `decodeOneOf`, mas ausencia e uma resposta valida - e o filtro "todos". */
export function decodeOptionalOneOf(code, codes) {
    return typeof code === 'string' ? codes[code] : undefined;
}
/** Como o `safeOneOf`, mas ausencia e uma resposta valida - e o filtro "todos". */
export function safeOptionalOneOf(value, allowed) {
    return allowed.includes(value) ? value : undefined;
}
/**
 * Texto de filtro vindo de fora.
 *
 * Corta no limite - um filtro de dez mil caracteres nao ajuda ninguem a buscar e vira
 * consulta cara - e recusa caractere de controle, que nao existe em busca digitada e
 * so aparece em endereco montado a mao.
 */
export function safeText(value, maxLength = 120) {
    if (typeof value !== 'string') {
        return undefined;
    }
    // eslint-disable-next-line no-control-regex
    const limpo = value.replace(/[\u0000-\u001F\u007F]/g, '').trim();
    return limpo ? limpo.slice(0, maxLength) : undefined;
}
/**
 * Uma data do endereco, no formato que a API fala: `AAAA-MM-DD`.
 *
 * Recusa o que nao tem essa forma E o que tem a forma mas nao existe no calendario -
 * `2026-02-31` casa com a expressao e nao e dia nenhum. O `Date` do JavaScript
 * normaliza em silencio (vira 3 de marco), entao a conferencia e comparar o que ele
 * devolve com o que foi pedido.
 *
 * Sem isto, uma data forjada viajaria ate o `LocalDate` do servidor, que responderia
 * 400 - e o painel leria o 400 como falha de busca, sem dizer que o endereco e que
 * estava torto.
 */
export function safeDate(value) {
    if (typeof value !== 'string' || !/^\d{4}-\d{2}-\d{2}$/.test(value)) {
        return undefined;
    }
    const date = new Date(`${value}T00:00:00Z`);
    return Number.isNaN(date.getTime()) || date.toISOString().slice(0, 10) !== value ? undefined : value;
}
export function safeSort(value, allowed) {
    if (typeof value !== 'string' || !value) {
        return undefined;
    }
    const descending = value.startsWith('-');
    const field = descending ? value.slice(1) : value;
    if (!allowed.includes(field)) {
        return undefined;
    }
    return descending ? `-${field}` : field;
}
//# sourceMappingURL=url.js.map